import { AppBridge } from './app-bridge';
import {
  parkingService,
  refuelingBarcodePaymentService,
  refuelingPassService,
  refuelingService,
} from './common/service';
import { API } from './constants/api';
import { DEVICE_OS, DEVICE_PLATFORM } from './constants/device';
import { DISTRIBUTOR, DISTRIBUTOR_NAME } from './constants/distributor';
import {
  CAPTURE_TYPES,
  CAPTURE_TYPES_NAME,
  PAYMENT_METHODS,
  PAYMENT_METHODS_NAME,
  PAYMENT_STATE,
} from './constants/payments';
import {
  RECEIPT_NAME,
  RECEIPT_NAME_NONE_MEMBER,
  RECEIPT_TYPES,
} from './constants/receipt';
import {
  POI_PAYMENT_TYPES,
  SERVICES,
  TRANSACTION_TYPES,
} from './constants/services';
import {
  ENERGY_SOURCE_NAME,
  OIL,
  VEHICLE,
  VEHICLE_NAME,
} from './constants/vehicle';
import { DOMAIN, ENV } from './domain/main';
import { useBodyScrollControl } from './hooks/use-body-scroll-control';
import useDeviceType from './hooks/use-device-type';
import useFetch from './hooks/use-fetch';
import useIntersect from './hooks/use-intersect';
import useInterval from './hooks/use-interval';
import useScroll from './hooks/use-scroll';
import useSiteInit from './hooks/use-site-init';
import useTaskQueue from './hooks/use-task-queue';
import useTimeout from './hooks/use-timeout';
import useVisualViewport from './hooks/use-visual-viewport';
import loveCodeJSON from './json/love_code.json';
import MqttService from './mqtt';
import { colorDetect } from './utils/color';
import { toCamelCase, toSnakeCase } from './utils/data-casing';
import { wait } from './utils/debugging';
import {
  getBrowser,
  getDeviceOS,
  getDevicePlateForm,
  getDeviceType,
  inWebview,
  isAppleDevice,
} from './utils/device';
import { getDistance, sortByDistance } from './utils/distance';
import { appDistributor } from './utils/distributor';
import { errorHandler } from './utils/error-handler';
import { formatter, timeFormatter } from './utils/formatter';
import { getImageUrl } from './utils/image';
import { loadJson, loadScript } from './utils/load';
import {
  getPoiPaymentName,
  getPoiPaymentType,
  isGasStationBarcodePayment,
  isGasStationMochipay,
  isGasStationPass,
  isInCooperate,
  isTaipeiCityParkinglots,
} from './utils/poi';
import { nl2br, snakeToCamel } from './utils/text';
import {
  generateModulePath,
  parseHash,
  parseSearch,
  pathGenerator,
} from './utils/url';
import validation, { passAllValidations } from './utils/validation';

export * from './constants/city';

export {
  // constants
  API,
  // app bridge
  AppBridge,
  appDistributor,
  CAPTURE_TYPES,
  CAPTURE_TYPES_NAME,
  colorDetect,
  DEVICE_OS,
  DEVICE_PLATFORM,
  DISTRIBUTOR,
  DISTRIBUTOR_NAME,
  DOMAIN,
  ENERGY_SOURCE_NAME,
  // domain
  ENV,
  // utils
  errorHandler,
  formatter,
  generateModulePath,
  getBrowser,
  getDeviceOS,
  getDevicePlateForm,
  getDeviceType,
  getDistance,
  getImageUrl,
  getPoiPaymentName,
  getPoiPaymentType,
  inWebview,
  isAppleDevice,
  isGasStationBarcodePayment,
  isGasStationMochipay,
  isGasStationPass,
  isInCooperate,
  isTaipeiCityParkinglots,
  loadJson,
  loadScript,
  loveCodeJSON,
  // mqtt
  MqttService,
  nl2br,
  OIL,
  // common
  parkingService,
  parseHash,
  parseSearch,
  passAllValidations,
  pathGenerator,
  PAYMENT_METHODS,
  PAYMENT_METHODS_NAME,
  PAYMENT_STATE,
  POI_PAYMENT_TYPES,
  RECEIPT_NAME,
  RECEIPT_NAME_NONE_MEMBER,
  RECEIPT_TYPES,
  refuelingBarcodePaymentService,
  refuelingPassService,
  refuelingService,
  SERVICES,
  snakeToCamel,
  sortByDistance,
  timeFormatter,
  toCamelCase,
  toSnakeCase,
  TRANSACTION_TYPES,
  useBodyScrollControl,
  useDeviceType,
  useFetch,
  // hook
  useIntersect,
  useInterval,
  useScroll,
  useSiteInit,
  useTaskQueue,
  useTimeout,
  useVisualViewport,
  validation,
  VEHICLE,
  VEHICLE_NAME,
  wait,
};
